import React from 'react'
import { Button, Form, message, Modal } from 'antd'
import { OPERATIONS } from '../constants'
import _ from 'lodash'

const mapOperationCaption = (type) => OPERATIONS[type]?.caption

const buildSuccessMessage = (key, data) => {
  const content = Array.isArray(data)
    ? `Операции ${mapOperationCaption([data[0]?.operation_type])} (${_.join(
        data.map(({ id }) => id),
        ','
      )}) выполнены успешно`
    : `Операция ${mapOperationCaption(data?.operation_type)} (${data?.id}) выполнена успешно`
  message.success({ key, content })
}

const InventoryOperationModalForm = ({
  title,
  formName,
  messageKey,
  showModal,
  onValuesChange,
  onFinish,
  onCancel,
  validator = () => true,
  children,
}) => {
  const [form] = Form.useForm()

  const onFinishAction = async (data) => {
    if (validator(data)) {
      try {
        const inventoryResult = await onFinish(data)
        buildSuccessMessage(messageKey, inventoryResult)
        clear()
      } catch (err) {
        onErrorAction(err.error)
      }
    }
  }

  const onErrorAction = ({ name, status, message: errorMessage }) => {
    message.error({
      key: messageKey,
      content: `Ошибка (${name}, статус: ${status}): '${errorMessage}' `,
    })
  }

  const clear = () => {
    form.resetFields()
  }

  const onCancelClick = () => {
    onCancel()
    clear()
  }

  return (
    <Modal
      title={title}
      visible={showModal}
      onCancel={onCancelClick}
      footer={[
        <Button key="back" onClick={onCancelClick}>
          Отмена
        </Button>,
        <Button key="save" type="primary" onClick={() => form.submit()}>
          Создать
        </Button>,
      ]}
    >
      <Form
        name={formName}
        autoComplete="off"
        layout="horizontal"
        onFinish={onFinishAction}
        onValuesChange={onValuesChange}
        form={form}
        size="large"
      >
        {children}
      </Form>
    </Modal>
  )
}

export default InventoryOperationModalForm
